import '../stylesheets/contact.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEnvelope, faPhone, faLocationDot } from '@fortawesome/free-solid-svg-icons';
import { faGithub, faLinkedin, faWhatsapp } from '@fortawesome/free-brands-svg-icons';

const socialLinks = [
    {
        icon: faEnvelope,
        label: 'Email',
        value: 'mostafa@aboelkheir.com',
        href: 'mailto:mostafa@aboelkheir.com',
        color: '#ea4335',
    },
    {
        icon: faLinkedin,
        label: 'LinkedIn',
        value: 'mostafa-abu-elkhair',
        href: 'https://www.linkedin.com/in/mostafa-abu-elkhair/',
        color: '#0077b5',
    },
    {
        icon: faGithub,
        label: 'GitHub',
        value: 'mostafa-abuelkhair',
        href: 'https://github.com/mostafa-abuelkhair',
        color: '#e2e8f0',
    },
    {
        icon: faWhatsapp,
        label: 'WhatsApp',
        value: '+20 106 606 8795',
        href: 'https://wa.me/201066068795',
        color: '#25d366',
    },
];

function Contact() {
    return (
        <section className="contact-section reveal" id="contact">

            <h2 className="section-title">
                <span className="section-number">05.</span> Get In Touch
            </h2>

            <div className="contact-layout">

                {/* Left: Info */}
                <div className="contact-info reveal">
                    <p className="contact-blurb">
                        I'm currently open to new opportunities. Whether you have a project in mind,
                        want to collaborate, or just want to say hi — my inbox is always open!
                    </p>

                    <div className="info-items">
                        <div className="info-item">
                            <FontAwesomeIcon icon={faLocationDot} className="info-icon" />
                            <span>Qalyubia Governorate, Egypt</span>
                        </div>
                        <div className="info-item">
                            <FontAwesomeIcon icon={faEnvelope} className="info-icon" />
                            <a href="mailto:mostafa@aboelkheir.com">mostafa@aboelkheir.com</a>
                        </div>
                        <div className="info-item">
                            <FontAwesomeIcon icon={faPhone} className="info-icon" />
                            <a href="tel:+201066068795">+20 106 606 8795</a>
                        </div>
                    </div>

                    <div className="social-links">
                        {socialLinks.map((s, i) => (
                            <a
                                key={i}
                                href={s.href}
                                target={s.href.startsWith('mailto') || s.href.startsWith('tel') ? '_self' : '_blank'}
                                rel="noopener noreferrer"
                                className="social-card"
                                style={{ '--social-color': s.color }}
                                title={s.label}
                            >
                                <FontAwesomeIcon icon={s.icon} className="social-icon" />
                                <div className="social-text">
                                    <span className="social-label">{s.label}</span>
                                    <span className="social-value">{s.value}</span>
                                </div>
                            </a>
                        ))}
                    </div>
                </div>

                {/* Right: Message Form */}
                <div className="contact-form-wrapper reveal">
                    <form className="message-form" action="/message.php" method="POST">
                        <div className="form-group">
                            <label htmlFor="name">Your Name</label>
                            <input type="text" id="name" name="name" placeholder="John Doe" required />
                        </div>
                        <div className="form-group">
                            <label htmlFor="from">Email Address</label>
                            <input type="email" id="from" name="from" placeholder="john@example.com" required />
                        </div>
                        <div className="form-group">
                            <label htmlFor="subject">Subject</label>
                            <input type="text" id="subject" name="subject" placeholder="Project Inquiry" />
                        </div>
                        <div className="form-group">
                            <label htmlFor="body">Message</label>
                            <textarea id="body" name="body" rows="6" placeholder="Tell me about your project..." required />
                        </div>
                        <button type="submit" className="submit-btn">
                            Send Message
                            <FontAwesomeIcon icon={faEnvelope} style={{ marginLeft: '10px' }} />
                        </button>
                    </form>
                </div>

            </div>

        </section>
    );
}

export default Contact;
